export const insertVendorTransactionMutation = (builder) => ({
    insertVendorTransaction: builder.mutation({
        query: (credentials) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: '/vendor_wallet',
                method: 'POST',
                body: credentials,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});